var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrammarDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 68,
    viewBox: "0 0 306 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102 48.5916C83.6342 48.1666 81.6984 20.7305 102 19.4555V0C57.9504 1.36944 55.4009 65.4499 102 67.9999V48.5916Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.539 48.5916C186.173 48.1666 184.238 20.7305 204.539 19.4555V0C160.489 1.36944 157.94 65.4499 204.539 67.9999V48.5916Z",
    fill: "#082C4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19617e-05 0C44.0496 1.36944 46.5991 65.4499 4.19617e-05 67.9999V0Z",
    fill: "#3098F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170 68C125.95 66.652 123.401 3.57274 170 1.06258V68Z",
    fill: "#FE6571"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M272.004 68C227.954 66.6306 225.405 2.55009 272.004 9.15527e-05V68Z",
    fill: "#FE6571"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M272 2.97237e-06C316.05 1.36944 318.599 65.4499 272 67.9999L272 2.97237e-06Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrammarDesktop);
export default __webpack_public_path__ + "static/media/grammar-desktop.2f4f01dc7d89358b92dc5fc2dd0486bc.svg";
export { ForwardRef as ReactComponent };